import { memo } from 'react';
import { IRankingPlayer } from '../..';
import { Element, Image, Menu } from '@zmedia/bm-soccer-ui/components';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import styles from './style.module.scss';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';

function StatsPlayer({ items = [] }: { items: IRankingPlayer[] }) {
    const renderStatPlayer = (item: IRankingPlayer, index: number) => {
        if (!item.id) {
            return null;
        }
        return (
            <Menu.List.Item className={styles['stats-player-item']} key={index}>
                <Avatar avatar={item.player.avatar} name={item.player.name} />
                <Element className={styles['player-info']}>
                    <Element className={styles['text']}>
                        {item.player.name}
                    </Element>
                    <Element className={styles['sub-text']}>
                        <Image src={item.team.logo} alt={item.team.name} />
                        {item.team.name}
                    </Element>
                </Element>
                <Element className={styles['player-score']}>
                    {item.value}
                </Element>
            </Menu.List.Item>
        );
    };

    const renderStatPlayers = (items: IRankingPlayer[] = []) => {
        return items.map((item: IRankingPlayer, index: number) => {
            return renderStatPlayer(item, index);
        });
    };

    if (ArrayUtils.isEmpty(items)) {
        return null;
    }

    return (
        <Menu.List className={styles['stats-player-list']}>
            {renderStatPlayers(items)}
        </Menu.List>
    );
}

export default memo(StatsPlayer);
